import { FC, useEffect, useRef, useState } from 'react'

import { Button, Card, CheckBox, Row, Tab } from 'components'
import { useAuth, useLoading, useModal, useToggle } from 'hooks'
import {
  EffectiveConsolidationServices,
  IEffectiveConsolidation,
  IGetAllEffectiveConsolidationDto,
  ReportsConsolidationServices
} from 'services/NGT/EffectiveConsolidation'
import {
  ConsolidationServices,
  IConsolidation,
  ISaveConsolidation
  //IAggregatedConsolidacaoEfetivo
} from 'services/NGT/Parameterization'
import { COLORS, SPACING } from 'utils'

import { TableActions } from './components'
import BaseAnalysisModal from './components/BaseAnalysisModal/BaseAnalysisModal'
import ReportAdhesionTotalized from './components/ReportAdhesionTotalized/ReportAdhesionTotalized'
import ReportEffetiveQuantity from './components/ReportEffetiveQuantity/ReportEffetiveQuantity'
import ReportHntHe from './components/ReportHntHe/ReportHntHe'
import ReportPayroll from './components/ReportPayroll/ReportPayroll'
import ReportTurnOver from './components/ReportTurnOver/ReportTurnOver'
import { useHistory } from 'react-router-dom'

export interface IEffetiveConsolidation {
  flRecorrente?: boolean
}

export const downloadURI = (uri, name) => {
  const link = document.createElement('a')
  link.download = name
  link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${uri}`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const EffectiveConsolidation: FC = () => {
  const { setLoading, setMsgErro } = useLoading()
  const { user } = useAuth()
  const { showModal } = useModal()
  const [tabs, setTabs] = useState(['Consolidação Efetivo'])
  const [selectedTab, setSelectedTab] = useState(0)
  const [flRecorrente, setFlRecorrente] = useState(false)
  const [listDiretoriaExecutiva, setListDiretoriaExecutiva] = useState<any[]>(
    []
  )
  const [requesting, setRequesting] = useState(false);
  const [listEmpresa, setListEmpresa] = useState<any[]>([])
  const [listArea, setListArea] = useState<any[]>([])
  const [listUnidadeNegocio, setListUnidadeNegocio] = useState<any[]>([])
  const [effectivesTableData, setEffectivesTableData] =
    useState<IGetAllEffectiveConsolidationDto>({
      flDiaFechamentoAnalista: false,
      itensConsolidacao: []
    })
  const isFirstRender = useRef(true);
  const [newArrayClearData, setNewArrayClearData] = useState<
    IEffectiveConsolidation[]
  >([])
  const [openBaseAnalysisModal, toggleBaseAnalysisModal] = useToggle()
  const [consolidacaoChange, setConsolidacaoChange] = useState(false)

  const handleChange = (_, newValue) => {
    setSelectedTab(newValue)
  }

  const handleClickCheckBox = (checked: boolean) => {
    setFlRecorrente(checked)
  }

  const generateExcelBaseAnalise = async (data: any) => {
    setLoading('loading')

    ReportsConsolidationServices()
      .GetExcelBaseAnalise(data)
      .then((response) => {
        if (response.status === 200) {
          if (response.data != '')
            downloadURI(response.data, `base-analise.xlsx`)
          else
            showModal({
              hideButtonCancel: true,
              message:
                `Não foram encontrado dados para o período de competência selecionado!
                \n\n Verifique se existem Consolidações incompletas e então consolide novamente!`,
              txtButtonConfirm: 'Fechar',
              type: 'alert'
            })
        }
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.mensagem ||
            error.message ||
            'Não foi possivel fazer o download da planilha Base Análise',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const verificarConsolidacoesIncompletas = (): boolean => {
    return (
      effectivesTableData.itensConsolidacao.find(
        (e) =>
          e.areaId === 0 ||
          e.areaId === null ||
          e.diretoriaExecutivaId === 0 ||
          e.diretoriaExecutivaId === null ||
          e.empresaId === 0 ||
          e.empresaId === null ||
          e.unidadeNegocioId === 0 ||
          e.unidadeNegocioId === null
      ) != undefined
    )
  }

  const isCompetenciaConsolidada = () =>
    effectivesTableData.itensConsolidacao.every(
      (consolidacao) => consolidacao.flConsolidado
    )

  const handleAuxiliaryWorksheet = async () => {
    await updateEffectiveData(effectivesTableData)
    const isIncomplete = verificarConsolidacoesIncompletas()

    if (isIncomplete) {
      showModal({
        handleConfirm: () => {
          setTabs([
            'Consolidação Efetivo',
            'Quantidade Efetivo',
            'HNT x HE',
            'Folha de Pagamento'
          ])
          setSelectedTab(1)
        },
        message:
          'Ainda existem Unidades Gestoras que não foram relacionadas, deseja continuar mesmo assim?',
        txtButtonCancel: 'NÃO',
        txtButtonConfirm: 'SIM',
        type: 'alert'
      })
    } else {
      setTabs([
        'Consolidação Efetivo',
        'Quantidade Efetivo',
        'HNT x HE',
        'Folha de Pagamento'
      ])
      setSelectedTab(1)
    }
  }

  const handleEffectiveConsolidation = async () => {
    await updateEffectiveData(effectivesTableData)

    const isIncomplete = effectivesTableData.itensConsolidacao.find(
      (e) =>
        e.areaId === 0 ||
        e.areaId === null ||
        e.diretoriaExecutivaId === 0 ||
        e.diretoriaExecutivaId === null ||
        e.empresaId === 0 ||
        e.empresaId === null ||
        e.unidadeNegocioId === 0 ||
        e.unidadeNegocioId === null
    )

    if (isIncomplete) {
      showModal({
        handleConfirm: () => {
          setTabs(['Consolidação Efetivo', 'Turn Over', 'Adesão totalizadas'])
          setSelectedTab(1)
        },
        message:
          'Ainda existem Unidades Gestoras que não foram relacionadas, deseja continuar mesmo assim?',
        txtButtonCancel: 'NÃO',
        txtButtonConfirm: 'SIM',
        type: 'alert'
      })
    } else {
      setTabs(['Consolidação Efetivo', 'Turn Over', 'Adesão totalizadas'])
      setSelectedTab(1)
    }
  }

  const getEffectiveTableData = () => {
    if (!requesting) {
      setRequesting(true);
      setLoading('loading');
      EffectiveConsolidationServices()
        .GetConsolidationByCompetence(flRecorrente)
        .then(({ data, status, statusText }) => {
          if (status !== 200) {
            throw new Error(statusText);
          }

          setEffectivesTableData(data.entity);

          if (data.entity.flDiaFechamentoAnalista) {
            showModal({
              hideButtonCancel: true,
              message:
                'O Dia Fechamento Analista ainda não foi fechado, aguarde.',
              txtButtonConfirm: 'OK',
              type: 'alert'
            });
          }

          setLoading('idle');
        })
        .catch(() => {
          setLoading('error');
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao carregar a lista de Unidades Gestoras',
            txtButtonConfirm: 'OK',
            type: 'alert'
          });
        })
        .finally(() => {
          setRequesting(false);
        });
    }
  }

  const updateEffectiveData = async (effectivesTableData) => {
    if (effectivesTableData.length > 0) {
      setLoading('loading')
      const requestData = []
      effectivesTableData.map((data) => {
        requestData.push({
          areaId: data.areaId,
          diretoriaExecutivaId: data.diretoriaExecutivaId,
          empresaId: data.empresaId,
          flConsolidado: data.flConsolidado,
          idConsolidacao: data.idConsolidacao,
          nuAnoMesCompetencia: data.nuAnoMesCompetencia,
          unidadeGestoraId: data.unidadeGestoraId,
          unidadeNegocioId: data.unidadeNegocioId
        })
      })

      try {
        const response =
          await EffectiveConsolidationServices().ConsolidacaoCreteOrUpdate(
            requestData
          )
        if (response.status !== 200)
          throw new Error(
            'Não foi possivel atualizar dados da Consolidação Efetivo, tente novamente!'
          )
        setLoading('idle')
      } catch (error: any) {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            'Não foi possivel atualizar dados da Consolidação Efetivo, tente novamente!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      }
    }
  }

  const verifyContractsPendingValidation = async () => {
    setLoading('loading')
    try {
      const response = await EffectiveConsolidationServices().ConsolidacaoVerificarContratosPendentesValidacao();
      if (response.status !== 200 || !response.data.sucesso) {
        showModal({
          hideButtonCancel: true,
          message:
            'Não foi possivel validar se há contratos pendentes de validação! Tente Novamente!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
        return false;
      }

      if (response.status === 200 && response.data.entity.contratosPendentesValidacao) {
        const excel = response.data.entity.base64Excel;
        const handleDownload = base64ToXlsxAndDownload({ base64Data: excel, filename: 'cdContratos_nao_validados_ou_nao_cadastrados.xlsx' });
        showModal({
          handleConfirm: handleDownload,
          message: `Não é possivel prosseguir com o processo de consolidação! Há contratos cadastrados não validados! Deseja baixar um relatório com os códigos dos contratos?`,
          txtButtonCancel: 'Fechar',
          txtButtonConfirm: 'Baixar',
          type: 'error'
        })
        setLoading('idle');
        return false;
      }
      setLoading('idle');
      return true;
    } catch (error: any) {
      showModal({
        hideButtonCancel: true,
        message:
          'Não foi possivel validar se há contratos pendentes de validação! Tente Novamente!',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
      setLoading('error')
      return false;
    }
  }

  const handleConfirmConsolidation = () => {
    setLoading('loading')

    EffectiveConsolidationServices()
      .PatchConfirmarConsolidacao(0, effectivesTableData.itensConsolidacao)
      .then(({ data, status, statusText }) => {
        if (status !== 200) {
          throw new Error(statusText)
        }

        if (data.sucesso) {
          showModal({
            hideButtonCancel: true,
            message: 'Dados atualizados com sucesso',
            txtButtonConfirm: 'OK',
            type: 'success'
          })

          getEffectiveTableData()
        } else {
          showModal({
            hideButtonCancel: true,
            message:
              data.mensagem ||
              'Não existem consolidações para esta competência',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        }

        setLoading('idle')
      })
      .catch((error) => {
        setLoading('error')
        showModal({
          hideButtonCancel: true,
          message: error.mensagem || error.message || 'Erro ao confirmar Consolidação, tente novamente!',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      })
  }

  const handleChangeDirExecutiva = (value, index) => {
    effectivesTableData.itensConsolidacao[index].diretoriaExecutivaId = value
    setEffectivesTableData({ ...effectivesTableData })
    setTabs(tabs.slice(0, 1))
    setConsolidacaoChange(true)
  }

  const handleChangeEmpresa = (value, index) => {
    effectivesTableData.itensConsolidacao[index].empresaId = value
    setEffectivesTableData({ ...effectivesTableData })
    setTabs(tabs.slice(0, 1))
    setConsolidacaoChange(true)
  }

  const handleChangeArea = (value, index) => {
    effectivesTableData.itensConsolidacao[index].areaId = value
    setEffectivesTableData({ ...effectivesTableData })
    setTabs(tabs.slice(0, 1))
    setConsolidacaoChange(true)
  }

  const handleChangeUniNegocio = (value, index) => {
    effectivesTableData.itensConsolidacao[index].unidadeNegocioId = value
    setEffectivesTableData({ ...effectivesTableData })
    setTabs(tabs.slice(0, 1))
    setConsolidacaoChange(true)
  }

  const [buttonClicked, setButtonClicked] = useState(false);
  const [confirmButtonEnabled, setConfirmButtonEnabled] = useState(true);


  const handleSaveButtonClick = () => {
    if (buttonClicked) {
      setConfirmButtonEnabled(false);
    }
  }

  const handleClick = () => {
    setButtonClicked(true)
    setConsolidacaoChange(false)
  };

  useEffect(() => {
    if (buttonClicked) {
      handleSaveConsolidation(effectivesTableData.itensConsolidacao)
    }
  }, [buttonClicked])

  const handleSaveConsolidation = (data) => {
    setLoading('loading')
    setButtonClicked(false)
    const consolidationState: ISaveConsolidation = {
      consolidacoes: data.map((item) => {
        return {
          areaId: item.areaId,
          diretoriaExecutivaId: item.diretoriaExecutivaId,
          empresaId: item.empresaId,
          flConsolidado: item.flConsolidado,
          idConsolidacao: item.idConsolidacao,
          nuAnoMesCompetencia: item.nuAnoMesCompetencia,
          unidadeGestoraId: item.unidadeGestoraId,
          unidadeNegocioId: item.unidadeNegocioId
        } as IConsolidation
      })
    }

    ConsolidationServices()
      .saveConsolidation(consolidationState)
      .then(({ status }) => {
        setLoading('idle')
        if (status === 200) {
          showModal({
            hideButtonCancel: true,
            message: 'Consolidação salva com sucesso',
            txtButtonConfirm: 'OK',
            type: 'success'
          })
          handleSaveButtonClick()
        }
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao salvar dados da consolidação',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const clearEffectiveData = () => {
    effectivesTableData.itensConsolidacao.map((effectiveItem) => {
      newArrayClearData.push({
        areaId: null,
        diretoriaExecutivaId: null,
        empresaId: null,
        flConsolidado: false,
        idConsolidacao: effectiveItem.idConsolidacao,
        nmUnidadeGestora: effectiveItem.nmUnidadeGestora,
        nuAnoMesCompetencia: effectiveItem.nuAnoMesCompetencia,
        unidadeGestoraId: effectiveItem.unidadeGestoraId,
        unidadeNegocioId: null
      })
    })
  }

  const handleClearButton = async () => {
    setFlRecorrente(false);
    await clearEffectiveData()
    setTabs(tabs.slice(0, 1))
    setEffectivesTableData((oldData) => ({
      ...oldData,
      ...newArrayClearData
    }))
    setNewArrayClearData([])
  }

  const handleConfirmButton = async () => {
    const progressToConfirm = await verifyContractsPendingValidation();

    if (progressToConfirm) {
      await updateEffectiveData(effectivesTableData)
      const isIncomplete = effectivesTableData.itensConsolidacao.find(
        (e) =>
          e.areaId === 0 ||
          e.areaId === null ||
          e.diretoriaExecutivaId === 0 ||
          e.diretoriaExecutivaId === null ||
          e.empresaId === 0 ||
          e.empresaId === null ||
          e.unidadeNegocioId === 0 ||
          e.unidadeNegocioId === null
      )

      if (isIncomplete) {
        showModal({
          handleConfirm: () => {
            handleConfirmConsolidation()
          },
          message:
            'Ainda existem Unidades Gestoras que não foram relacionadas, deseja continuar mesmo assim?',
          txtButtonCancel: 'NÃO',
          txtButtonConfirm: 'SIM',
          type: 'alert'
        })
      } else {
        showModal({
          handleConfirm: () => {
            handleConfirmConsolidation()
          },
          message:
            'Deseja realizar a consolidação de efetivos!',
          txtButtonCancel: 'NÃO',
          txtButtonConfirm: 'SIM',
          type: 'alert'
        })
      }
    }
  }

  useEffect(() => {
    const getExecutives = new Promise((res, rej) =>
      ConsolidationServices()
        .getAllExecutives()
        .then(({ data }) => res(data))
        .catch((err) =>
          // rej(err)
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao obter os dados da pesquisa',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        )
    )

    const getCompanys = new Promise((res, rej) =>
      ConsolidationServices()
        .getAllCompanies()
        .then(({ data }) => res(data))
        .catch((err) =>
          // rej(err)
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao obter os dados da pesquisa',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        )
    )

    const getArea = new Promise((res, rej) =>
      ConsolidationServices()
        .getAlltAreaConsolidation()
        .then(({ data }) => res(data))
        .catch((err) =>
          // rej(err)
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao obter as Áreas',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        )
    )

    const getBusiness = new Promise((res, rej) =>
      ConsolidationServices()
        .getAllBusinessUnit()
        .then(({ data }) => res(data))
        .catch((err) =>
          // rej(err)
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao obter os dados da pesquisa',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        )
    )

    const getData = async () => {
      try {
        const response = await Promise.allSettled([
          getExecutives,
          getCompanys,
          getArea,
          getBusiness
        ])

        response.forEach((el) => {
          if (el.status === 'rejected') {
            setMsgErro('Erro ao obter dados.')
            setLoading('error')
            return
          }
        })

        response[0].status === 'fulfilled' &&
          setListDiretoriaExecutiva(response[0].value as [])
        response[1].status === 'fulfilled' &&
          setListEmpresa(response[1].value as [])
        response[2].status === 'fulfilled' &&
          setListArea(response[2].value as [])
        response[3].status === 'fulfilled' &&
          setListUnidadeNegocio(response[3].value as [])

      } catch (error: any) {
        setLoading('error')
      }
    }

    getData()
    getEffectiveTableData()

  }, [])
  /*
  const history = useHistory();

  localStorage.setItem('DadosConsolidação', JSON.stringify(effectivesTableData.itensConsolidacao));
  
  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      console.log(history)
      // console.log('Page changed:', location.pathname);
      if(history.location.pathname != "/ngt/consolidacao-efetivo" && consolidacaoChange == true){
        const dadosConsolidacao = JSON.parse(localStorage.getItem('DadosConsolidação'));
        console.log(dadosConsolidacao)
        handleSaveConsolidation(dadosConsolidacao)
      }
     
      localStorage.removeItem('DadosConsolidação');
    });
    return () => {
      unlisten();
    };
  }, [history, consolidacaoChange]);
  
*/
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      getEffectiveTableData();
    }
  }, [flRecorrente]);

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 && (
        <Card
          marginLeft={SPACING.spacing20}
          marginRight={SPACING.spacing20}
          padding={SPACING.spacing20}
          marginBottom={SPACING.spacing100}
          boxShadow={`0 0 1em ${COLORS.lightGray}`}
        >
          <Row
            justifyContent="space-between"
            marginTop={SPACING.spacing10}
            marginBottom={SPACING.spacing10}
          >
            <CheckBox
              label="Apenas Recorrentes"
              checked={flRecorrente}
              onChange={(event) => {
                handleClickCheckBox(event.target.checked)
              }}
            />
            <Button
              text="Base Análise"
              onClick={() => toggleBaseAnalysisModal()}
              marginBottom={SPACING.spacing20}
            />
          </Row>

          <TableActions
            effectivesTableData={effectivesTableData.itensConsolidacao}
            listDiretoriaExecutiva={listDiretoriaExecutiva}
            listEmpresa={listEmpresa}
            listArea={listArea}
            listUnidadeNegocio={listUnidadeNegocio}
            handleChangeDirExecutiva={handleChangeDirExecutiva}
            handleChangeEmpresa={handleChangeEmpresa}
            handleChangeArea={handleChangeArea}
            handleChangeUniNegocio={handleChangeUniNegocio}
          />
          <Row
            justifyContent="end"
            marginTop={SPACING.spacing20}
            marginBottom={SPACING.spacing15}
          >
            <Button
              text="Planilha Auxiliar"
              variantButton="outlined"
              marginRight={SPACING.spacing10}
              onClick={() => {
                handleAuxiliaryWorksheet()
              }}
            />
            <Button
              text="Consolidação do Efetivo"
              onClick={() => {
                handleEffectiveConsolidation()
              }}
            />
          </Row>
          <Row
            justifyContent="end"
            marginTop={SPACING.spacing10}
            marginBottom={SPACING.spacing15}
          >
            <Button
              text="Limpar"
              variantButton="text"
              marginRight={SPACING.spacing10}
              onClick={() => {
                if (effectivesTableData.itensConsolidacao.length > 0) {
                  showModal({
                    handleConfirm: () => {
                      handleClearButton()
                    },
                    message:
                      'Você tem certeza que deseja limpar os dados na tela?',
                    txtButtonCancel: 'NÃO',
                    txtButtonConfirm: 'SIM',
                    type: 'alert'
                  })
                }
              }}
            />
            <Button
              text="Salvar"
              marginRight={SPACING.spacing10}
              onClick={handleClick}
            />
            {user.PerfilUsuarioId !== 6 && (
              <Button
                text="Confirmar"
                disabled={
                  effectivesTableData.flDiaFechamentoAnalista ||
                  isCompetenciaConsolidada() ||
                  verificarConsolidacoesIncompletas()
                  || confirmButtonEnabled
                }
                onClick={handleConfirmButton}
              />
            )}
          </Row>
          <BaseAnalysisModal
            showModal={openBaseAnalysisModal}
            toggleModal={toggleBaseAnalysisModal}
            handleSubmitCompetence={generateExcelBaseAnalise}
          />
        </Card>
      )}
      {selectedTab === 1 && tabs[1] === 'Quantidade Efetivo' && (
        <ReportEffetiveQuantity flRecorrente={flRecorrente} />
      )}
      {selectedTab === 2 && tabs[2] === 'HNT x HE' && <ReportHntHe flRecorrente={flRecorrente} />}
      {selectedTab === 3 && tabs[3] === 'Folha de Pagamento' && (
        <ReportPayroll flRecorrente={flRecorrente} />
      )}
      {selectedTab === 1 && tabs[1] === 'Turn Over' && <ReportTurnOver flRecorrente={flRecorrente} />}
      {selectedTab === 2 && tabs[2] === 'Adesão totalizadas' && (
        <ReportAdhesionTotalized flRecorrente={flRecorrente} />
      )}
    </>
  )
}

function base64ToXlsxAndDownload({ base64Data, filename }) {
  const handleDownload = () => {
    // Decodifica a string base64
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Cria um blob com os dados decodificados
    const blob = new Blob([byteArray], { type: 'xlsx' });

    const element = document.createElement('a');
    const file = blob;
    element.href = URL.createObjectURL(file);
    element.download = filename;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };
  return handleDownload;
}

export default EffectiveConsolidation
